import { createSlice } from '@reduxjs/toolkit'

const BasicsStatus = Object.freeze({
    LOADING: 'LOADING',
    SUCCESS: 'SUCCESS',
    FAILURE: 'FAILURE',
})

const initialState = {
    status: BasicsStatus.LOADING,
    errorMessage: null,
    newDetails: {},
}

const basicsSlice = createSlice({
    name: 'business/basics',
    initialState,
    reducers: {
        updateBasicsRequest: state => {
            state.status = BasicsStatus.LOADING
        },
        updateBasicsRequestSuccess: (state, action) => {
            state.status = BasicsStatus.SUCCESS
            state.newDetails = action.payload
        },
        updateBasicsRequestError: (state, action) => {
            state.errorMessage = action.payload
            state.status = BasicsStatus.FAILURE
        },
        reset: state => initialState,
    },
})

const {
    updateBasicsRequest,
    updateBasicsRequestSuccess,
    updateBasicsRequestError,
    reset,
} = basicsSlice.actions

export const businessBasicsActions = {
    updateBasicsRequest,
    updateBasicsRequestSuccess,
    updateBasicsRequestError,
    reset,
}

export const businessBasicsSelectors = {
    isFetching: state => state.businessBasics.status === BasicsStatus.LOADING,
    hasError: state => state.businessBasics.status === BasicsStatus.FAILURE,
    success: state => state.businessBasics.status === BasicsStatus.SUCCESS,
    errorMessage: state => state.businessBasics.errorMessage,
    newDetails: state => state.businessBasics.newDetails,
}

export default basicsSlice.reducer
